import React from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";

const RevenueCard = ({
  title,
  value,
  icon,
  color,
  bgColor,
}) => {
  return (
    <Card className="border-0 bg-white h-100">
      <CardBody className="d-flex align-items-center justify-content-between">
        <div>
          <p className="text-uppercase fw-semibold text-muted mb-1">
            {title}
          </p>

          <h4 className="fs-22 fw-bold text-dark mb-3">
            ₹
            <CountUp
              start={0}
              end={Number(value || 0)}
              duration={1.5}
              separator=","
              decimals={2}
            />
          </h4>
        </div>

        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: bgColor,
            width: "50px",
            height: "50px",
            borderRadius: "10px",
          }}
        >
          <i
            className={icon}
            style={{
              color,
              fontSize: "24px",
            }}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default RevenueCard;